<template>
  <d-row class="my-4">
    <d-col cols="12">
      <d-card>
        <d-card-header v-d-toggle.shop-settings-collapse class="cursor-pointer">
          <i
            class="material-icons mr-1 animate"
            :class="{ 'rotate-90': !collapsed }"
            >chevron_right</i
          >
          Shop Settings
        </d-card-header>
        <d-collapse
          id="shop-settings-collapse"
          @hide="collapsed = true"
          @show="collapsed = false"
        >
          <d-card-body>
            <form
              id="update-shop-settings-form"
              @submit.prevent="updateSettings"
            >
              <vue-form-generator
                :schema="schema"
                :model="model"
                :options="formOptions"
              />
              <input
                type="submit"
                form="update-shop-settings-form"
                value="save"
                class="btn btn-primary d-none"
              />
            </form>
          </d-card-body>
        </d-collapse>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import schema from "./schema";
import { keepKeys } from "@/helpers";

export default {
  data() {
    return {
      model: {},
      schema: schema.SHOP_SCHEMA,
      formOptions: schema.SHOP_OPTIONS,
      collapsed: true
    };
  },
  created() {
    this.model = this.$store.state.settings.settings;
  },
  methods: {
    updateSettings() {
      const newSettings = keepKeys(this.model, schema.SHOP_KEYS);
      this.$store.dispatch("settings/updateSettings", newSettings).then(() => {
        this.$toasted.show(`Settings Updated Successfully!`, {
          position: "bottom-right",
          duration: 2000
        });
      });
    }
  }
};
</script>

<style></style>
